import React, { useMemo, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { View, Text, Pressable } from 'react-native';

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    margin: '20px 0px'
};

const activeStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

const removeItemStyle = {
  paddingLeft: '10px',
}

const descriptionStyle = {
  margin: '0px',
  padding: '40px 0px',
}

export const Dropzone = (props) => {

    // onDrop returns a function that will return our file.
    const onDrop = useCallback(
        ([file]) => {

          props.handleFile(file);
        }

    );

    const {
        acceptedFiles,
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({ accept: 'image/*', onDrop });

    const handleRemove = () => {
      acceptedFiles.pop()
    }

    const files = acceptedFiles?.map(file => (
        <li style={descriptionStyle} key={file?.path}>
            {file?.path} – {file.size} bytes
            <span style={removeItemStyle}><a href="#" onClick={handleRemove}>Remove</a></span>
        </li>
    ));

    const style = useMemo(() => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isDragActive,
        isDragReject
    ]);

    return (
        <section className="container">
            <div {...getRootProps({ style })}>
                <input {...getInputProps()} />
                { (files.length > 0) ? files
                  : <p style={descriptionStyle}>{props.description}</p> }
            </div>
        </section>
    );
}

export const MultiDropzone = (props) => {
  const onDrop = useCallback(droppedFiles => {
    const newFiles = props.files.concat(droppedFiles);
    if (props.setFiles) { props.setFiles(newFiles); }
    if (props.handleFiles) { props.handleFiles(newFiles); }
  });

  const handleRemove = useCallback((file, e) => {
    e.stopPropagation();

    let newFiles = props.files.filter(f => f.path !== file.path);
    if (props.setFiles) { props.setFiles(newFiles); }
    if (props.handleFiles) { props.handleFiles(newFiles); }
  });

  const filesList = (
    <ul style={descriptionStyle}>
      {props.files && props.files.length > 0 && props.files.map(file => (
        <li
          key={file.path}
          style={{paddingBottom: '10px'}}
        >
          {file.path || file.filename}{file.size ? ` - ${file.size} bytes` : ''}
          <a
            onClick={e => handleRemove(file, e)}
            style={removeItemStyle}
          >
            Remove
          </a>
        </li>
      ))}
    </ul>
  );

  const {
      acceptedFiles,
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject
  } = useDropzone({ accept: 'image/*', onDrop });

  const files = props.files?.map(file => (
      <li style={descriptionStyle} key={file.path}>
          {file.path} – {file.size} bytes
          <span style={removeItemStyle}><a href="#" onClick={handleRemove}>Remove</a></span>
      </li>
  ));

  const style = useMemo(() => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
  }), [
      isDragActive,
      isDragReject
  ]);

  return (
    <section className="container">
        <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            {props.files && props.files.length ? filesList : (
              <p style={{...descriptionStyle, ...props.descriptionStyle}}>
                {props.description}
              </p>
            )}
        </div>
    </section>
  );
}

export const AssetDocumentsDropzone = (props) => {
  const onDrop = useCallback(droppedFiles => {
    const newFiles = props.files.concat(droppedFiles);
console.log('newFiles in ondrop', newFiles)
    if (props.setFiles) { props.setFiles(newFiles); }
    if (props.handleFiles) { props.handleFiles(newFiles); }
  });

  const handleRemove = useCallback((file, e) => {
    e.stopPropagation();
console.log('props.files', props.files)
console.log('removed file', file)
    let newFiles = props.files.filter(f => {
      if(file.id) {
        return file.id !== f.id
      }else {
        return f.path !== file.path
      }
    });
console.log('newFiles in remove', newFiles)
    if (props.setFiles) { props.setFiles(newFiles); }
    if (props.handleFiles) { props.handleFiles(newFiles); }
  });

  const filesList = (
    <ul style={descriptionStyle}>
      {props.files && props.files.length > 0 && props.files.map((file, index) => (
        <li
          key={file?.path}
          style={{paddingBottom: '10px'}}
        >
          <View style={{display: 'flex', flexDirection: 'row', flex: 1}}>
            <Text>
              {file?.path || file?.filename}{file?.size ? ` - ${file?.size} bytes` : ''}
            </Text>
            <a
              onClick={e => handleRemove(file, e)}
              style={removeItemStyle}
            >
              Remove
            </a>
            <Pressable onPress={() => {}}>
              <View style={{display: 'flex', flexDirection: 'row', flex: 1}}>
                <Text
                  style={{marginLeft: '10px', marginRight: '10px', color: '#bdbdbd'}}
                >
                  File notes:
                </Text>
                {file?.path ?
                  <input
                    type='text'
                    style={{flex: 1}}
                    defaultValue={
                      props.fileNotes.map(note => {
                        if(note.attachmentId === file?.id) {
                          return note.body
                        }
                      })
                    }
                    onChange={(e) => {
                      let newFiles = props.files;
                      // newFiles[index]['notes'] = e.target.value;
                      // newFiles = newFiles.map((f, fIndex) => {
                      //   if(index === fIndex) {
                      //     newFiles[index]['notes'] = e.target.value
                      //   }else {
                      //     return f
                      //   }
                      // })
                      newFiles[index]['notes'] = e.target.value
                      if (props.setFiles) { props.setFiles(newFiles); }
                      if (props.handleFiles) { props.handleFiles(newFiles); }
                    }}
                  /> :
                  <Text>
                    {props.fileNotes.map(note => {
                      if(note.attachmentId === file?.id) {
                        return note.body
                      }
                    })}
                  </Text>
                }
              </View>
            </Pressable>
          </View>
        </li>
      ))}
    </ul>
  );

  const {
      acceptedFiles,
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject
  } = useDropzone({ accept: 'image/*', onDrop });

  const style = useMemo(() => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
  }), [
      isDragActive,
      isDragReject
  ]);

  return (
    <section className="container">
        <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            {props.files && props.files.length ? filesList : (
              <p style={{...descriptionStyle, ...props.descriptionStyle}}>
                {props.description}
              </p>
            )}
        </div>
    </section>
  );
}



